module.exports = __webpack_public_path__ + "src/assets/textures/env/well/well_bucket_256_bake.png";